import { defineStore } from "pinia";
import _rest from "../plugins/rest";

export const useAuthStore = defineStore("auth", {
    state: () => ({
        loggedIn: false,
        groups: null,
        permissions: null,
        user: null,
    }),
    getters: {
        employeeId(state) {
            return state?.user?.employee?.pk;
        },

        username(state) {
            if (state.user !== null) {
                return state.user.username;
            }
            return "";
        },

        lang(state) {
            if (state.user !== null) {
                return state.user.lang;
            }
            return "en";
        },

        root(state) {
            if (state.user !== null) {
                return state.user.root || false;
            }
            return false;
        },

        hasPerm(state) {
            return (perm) => {
                if (perm === "root") {
                    return state.root;
                }

                if (state.permissions !== null) {
                    if (Array.isArray(perm)) {
                        return perm.some((x) => state.permissions.has(x));
                    }
                    return state.permissions.has(perm);
                }
                return false;
            };
        },

        inGroup(state) {
            return (group) => {
                if (state.groups !== null) {
                    return state.groups.has(group);
                }
                return false;
            };
        },
    },
    actions: {
        async ping() {
            try {
                const response = await _rest.get("/auth/ping", undefined, { overlay: false });
                return response;
            } catch (_) {
                return "forbidden";
            }
        },
        initAuth(credentials = undefined) {
            if (credentials) {
                this.loggedIn = true;
                this.groups = new Set(credentials.groups);
                this.permissions = new Set(credentials.permissions);
                this.user = credentials.user;

                localStorage.setItem("AUTH-TOKEN", credentials.auth_token);
                localStorage.setItem("AUTH-GROUPS", JSON.stringify(credentials.groups));
                localStorage.setItem("AUTH-PERMISSIONS", JSON.stringify(credentials.permissions));
                localStorage.setItem("AUTH-USER", JSON.stringify(this.user));
            } else {
                const token = localStorage.getItem("AUTH-TOKEN");
                if (token) {
                    this.loggedIn = true;
                    this.groups = new Set(JSON.parse(localStorage.getItem("AUTH-GROUPS")));
                    this.permissions = new Set(JSON.parse(localStorage.getItem("AUTH-PERMISSIONS")));
                    this.user = JSON.parse(localStorage.getItem("AUTH-USER"));
                }
            }
        },

        clearAuth() {
            this.loggedIn = false;
            this.groups = null;
            this.permissions = null;
            this.user = null;

            localStorage.removeItem("AUTH-TOKEN");
            localStorage.removeItem("AUTH-GROUPS");
            localStorage.removeItem("AUTH-PERMISSIONS");
            localStorage.removeItem("AUTH-USER");
        },
    },
});
